// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog-wlVum","download":"download-PLFdU","header":"header-En3Gj","footer":"footer-mFFKe","title":"title-ULINV"};